export default __webpack_public_path__ + "static/jeonghyun.nam-5b40cd517d26f9c4229a316a73b30fba.png";